const TEXT = {
  GDPR_LABEL: 'European regulation (GDPR)',
  USP_LABEL: 'US regulation',
};

export default TEXT;
